// extracted by mini-css-extract-plugin
export default {"footerBg":"l-z","footerTopLinks":"m-z","footerFeedback":"n-z","footerSocial":"o-z","footerLegalLinks":"p-z","footerIconCards":"q-z","footerBotCopy":"r-z","screenReadersOnly":"s-z"};